import { vec3, quat, quat2 } from 'gl-matrix';

WL.registerComponent('smooth-locomotion', {
    player: { type: WL.Type.Object },
    head: { type: WL.Type.Object },
    colyseusObj: { type: WL.Type.Object },
    speed: { type: WL.Type.Float, default: 2 },
    isActive: { type: WL.Type.Bool, default: false },
    fly: { type: WL.Type.Bool, default: false },
    colObject: {type: WL.Type.Object},
    jumpPadSFX: {type: WL.Type.Object},
  }, {
  init: function () {
    // Do nothing if this controller isn't meant to smooth locomote
    if (!this.isActive) return;
    // Set up variables to store controller input data
    this.moveX = 0;
    this.moveY = 0;
    this.thumbstickPressed = false;
    this.moveVector = vec3.create();
    this.headRot = quat.create();

    // Physics body
    this.world;
    this.body = null;
    this.velocity = vec3.create();
    this.lastPos = vec3.create();
    this.headPos = vec3.create();
    this.pxDirection = vec3.create();
    this.tempPose = quat2.create();
    this.tempPose2 = quat2.create();

    // Jump Possiblity
    this.jump = false;

    //Canon RayCast Constants
    this.launch = false;
    this.collider = this.colObject.getComponent('collision');
    this.jpSFX = this.jumpPadSFX.getComponent('howler-audio-source');

    this.turnControls = this.object.getComponent('turn-controls');
    
    // Hook up event listeners for the relevant movement input events.
    PP.LeftGamepad.registerAxesEventListener(PP.AxesEvent.AXES_CHANGED, 'move', axes => {
      this.moveX = axes.myAxes[0];
      this.moveY = axes.myAxes[1];
    });
    PP.RightGamepad.registerButtonEventListener(PP.ButtonType.BOTTOM_BUTTON, PP.ButtonEvent.PRESS_START, 0, () => {
      if(!this.jump) {
        this.jump = true;
        let storeX = this.body.linearVelocity[0];
        let storeZ = this.body.linearVelocity[2];
        this.body.linearVelocity = [storeX, 0, storeZ];
        this.body.addForce([0, 7.5, 0], WL.ForceMode.Impulse);
        setTimeout(() => {this.jump = false}, 2000);
      }
    });

    this.body = this.object.getComponent('physx');
    this.body.staticFriction = 0;
    this.body.dynamicFriction = 0;
    this.body.active = false;
    setTimeout(() => {
      // Prevent body from sinking through floor at start
      this.body.active = true;
      this.body.linearVelocity = [0, 0, 0];
    }, 1000);

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'hidden') {
        // For whatever reason Pico changes the visibilitystate on session entry
        // They also still have WebVR APIs available, which we can use to detect
        // And make sure the body isn't deactivated on startup
        if (typeof navigator.getVRDisplays === 'function') {
          const VRDisplays = await navigator.getVRDisplays();
          if (VRDisplays[0].displayName === 'Pico') return;
        } else {
          // Prevents physics force buildup on Meta browser
          this.body.active = false;
        }
      }
      else {
        // Wait ~1 frame to reactivate the physics component
        setTimeout(() => {
          this.body.active = true;
          // Wait ~1 frame to ensure body is dynamic with 0 latent velocity
          setTimeout(() => {
            this.body.kinematic = false;
            this.body.linearVelocity = [0, 0, 0];
          }, 15)
        }, 15);
      }
    });
  },
  start: function () {
    this.colyseus = this.colyseusObj.getComponent('colyseus');
  },
  update: function (dt) {
    // Do nothing if this controller isn't meant to smooth locomote
    if (!this.isActive) return;

    if (this.body != null) {

      // Adjust body collider based on head location
      //this.handleHead();

      // If there's input coming in, move the player
      if (Math.abs(this.moveX + this.moveY) > 0) {
        this.move(this.moveX, this.moveY, dt / 1000);
      } else {
        let storeY = this.body.linearVelocity[1];
        this.body.linearVelocity = [0, storeY, 0];
      }

    }

    let collidingComps = this.collider.queryOverlaps();
    if (collidingComps.length > 0  && !this.launch){
      for (let i = 0; i < collidingComps.length; i++) {
      if(collidingComps[i].object.name == "CanonCol")this.launchChar();
      }
    }
    collidingComps = [];
  },
  launchChar: function(){
    this.launch = true;
    this.jpSFX.play();
    let storeX = this.body.linearVelocity[0];
    let storeZ = this.body.linearVelocity[2];
    this.body.linearVelocity = [storeX, 0, storeZ];
    this.body.addForce([0, 15, 0], WL.ForceMode.Impulse);
    this.toggleSnap();
    setTimeout(() => {
      this.launch = false;
    }, 500);
  },
  toggleSnap: function () {
    // Prevent physics glitch from snapturning on frame directly after launch
    this.turnControls.canSnap = false;
    setTimeout(() => {
      this.turnControls.canSnap = true;
    }, 50);
  },
  move: function (x, y) {

    vec3.set(this.moveVector, x, 0, y);
    vec3.normalize(this.moveVector, this.moveVector);
    vec3.scale(this.moveVector, this.moveVector, this.speed);
    vec3.transformQuat(this.moveVector, this.moveVector, this.head.transformWorld);

    // Move player (PhysX)
    vec3.set(this.pxDirection, this.moveVector[0], this.body.linearVelocity[1], this.moveVector[2]);
    this.body.linearVelocity = this.pxDirection;

    // Stand Still Test
    // if (x > -0.25 && x < 0.25 && y > -0.25 && y < 0.25)   this.body.linearVelocity = [0,0,0];

  },
  handleHead: function () {
    this.headPos.setFromMatrixPosition(this.head.object3D.matrixWorld);
    this.tempPose.translation = {
      x: this.headPos.x - this.player.object3D.position.x,
      y: this.headPos.y / (2 + this.player.object3D.position.y),
      z: this.headPos.z - this.player.object3D.position.z
    }
    this.tempPose.rotation = { w: 1, x: 0, y: 0, z: 0 };
    this.body.shapes[0].setLocalPose(this.tempPose);
  }
});

const TURN_TYPES = {
  'none': 0,
  'snap': 1,
  'smooth': 2,
}

WL.registerComponent('turn-controls', {
    player: { type: WL.Type.Object },
    head: { type: WL.Type.Object },
    colyseusObj: { type: WL.Type.Object },
    turnType: { type: WL.Type.Enum, default: 'none', values: Object.keys(TURN_TYPES) },
    snapDegrees: { type: WL.Type.Float, default: 15 },
    turnSpeed: { type: WL.Type.Float, default: 10 }
  }, {
  init: function () {
    // Do nothing if this controller isn't meant to turn or the turnType is invalid
    if (this.turnType == TURN_TYPES.none) return;
    this.invalid = this.turnType != TURN_TYPES.snap && this.turnType != TURN_TYPES.smooth;
    if (this.invalid) {
        console.log("You have not entered a valid turnType! Only none, snap, and smooth are accepted.");
        return;
    }

    // Set up variables to read controller input and control turn logic
    this.rotateX = 0;
    this.rotateY = 0;
    this.justSnapped = false;
    this.snapThreshold = .97;
    this.canSnap = true;

    // Set up variables to facilitate position adjustment during turn
    this.preRotHeadPos = vec3.create();
    this.headPos = vec3.create();
    this.offset = vec3.create();
    this.velocity = vec3.create();
    this.bodyPos = vec3.create();
    this.upVector = vec3.fromValues(0, 1, 0);
    this.rotQuaternion = quat.create();

    // Physics
    this.body = this.object.getComponent('physx');

    // Hook up event listeners for the relevant turning input events
    PP.RightGamepad.registerAxesEventListener(PP.AxesEvent.AXES_CHANGED, 'move', axes => {
      this.rotateX = axes.myAxes[0];
      this.rotateY = axes.myAxes[1];
    });
  },
  start: function () {
    this.colyseus = this.colyseusObj.getComponent('colyseus');
    this.physics = this.player.getComponent('physx');
  },
  update: function (time, timeDelta) {
    // Do nothing if this controller isn't meant to turn or the turnType is invalid
    if (this.turnType == TURN_TYPES.none || this.invalid || !this.body) return;
    // Turn based on schema
    if (this.turnType == TURN_TYPES.snap && this.canSnap) this.snapTurn();
    if (this.turnType == TURN_TYPES.smooth) this.smoothTurn(timeDelta / 1000);
  },
  snapTurn: function () {
    // If player hasn't snapped yet and input is over snapThreshold, rotate the player by snapDegrees
    if (!this.justSnapped && Math.abs(this.rotateX) > this.snapThreshold) {
      this.head.getTranslationWorld(this.preRotHeadPos);
      this.player.getTranslationWorld(this.bodyPos);
      const theta = this.snapDegrees * (Math.PI / 180) * (this.rotateX < 0 ? 1 : -1);
      quat.fromEuler(this.rotQuaternion, theta, 0, 0);

      this.rotateAround(theta);

      this.justSnapped = true;
    }
    // If player has snapped, check to see if they're now under snapThreshold
    else if (this.rotateX > -this.snapThreshold && this.rotateX < this.snapThreshold)
      this.justSnapped = false;
  },
  smoothTurn: function (dt) {
    // FIXME: This hasn't been converted yet, wasn't functioning properly in old build either.
    // Implement after snapturning

    // If there's input, rotate the player smoothly
    if (this.rotateX != 0) {
      this.head.getTranslationLocal(this.preRotHeadPos);
      const body = this.player;
      const rotationPoint = this.preRotHeadPos.clone();
      rotationPoint[1] = 0;
      const theta = -this.rotateX * dt * this.turnSpeed;
      this.rotateAround(body, rotationPoint, this.upVector, theta, true);

      let q = body.quaternion;
      this.body.rigidBody.setGlobalPose({
        translation: { x: body.position.x, y: body.position.y, z: body.position.z },
        rotation: { w: q.w, x: q.x, y: q.y, z: q.z }
      }, true);

      if (this.colyseus.room) {
        console.log(q);
        this.colyseus.room.send('turn', {
          w: q.w,
          x: q.x,
          y: q.y,
          z: q.z
        });
      }
    }
  },
  rotateAround: function(theta) {
    // Temporarily toggle player rigidbody to kinematic
    vec3.copy(this.velocity, this.physics.linearVelocity);
    this.physics.kinematic = true;

    // Set a timeout so the following code gets executed at approximately next frame
    setTimeout(() => {
      // Rotate player object
      this.player.rotateAxisAngleRadObject([0, 1, 0], theta);

      // Get offset of current head position minus previous head position
      this.head.getTranslationWorld(this.headPos);
      vec3.sub(this.offset, this.headPos, this.preRotHeadPos);
      this.offset[1] = 0;

      // Subtract offset from body position and apply to player
      vec3.sub(this.bodyPos, this.bodyPos, this.offset);
      this.player.setTranslationWorld(this.bodyPos);

      // Set another timeout to toggle rigidbody back to dynamic
      // Velocity needs to be zeroed out to avoid being flung from angular momentum
      setTimeout(() => {
        this.physics.kinematic = false;
        this.physics.linearVelocity = this.velocity;
      }, 15);
    }, 15);
  }
});
